import { render, staticRenderFns } from "./RegInstructions.vue?vue&type=template&id=77b2c218&scoped=true&"
import script from "./RegInstructions.vue?vue&type=script&lang=js&"
export * from "./RegInstructions.vue?vue&type=script&lang=js&"
import style0 from "./RegInstructions.vue?vue&type=style&index=0&id=77b2c218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2c218",
  null
  
)

export default component.exports